<template>
  <InputComponent v-bind="$attrs" v-on="$listeners">
    <template #default>
      <slot name="default"> </slot>
    </template>
  </InputComponent>
</template>

<script>
import InputComponent from '../components/Input.vue'

export default {
  components: {
    InputComponent,
  },
}
</script>
